class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverCloseTimer = null;

    if (this.summary && this.summary.classList.contains('pbm-header-nav__item')) {
      this.bindPBMHoverMenu();
    }
  }

  bindPBMHoverMenu() {
    this.addEventListener('mouseenter', () => this.openPBMHoverMenu());
    this.addEventListener('mouseleave', () => this.queuePBMHoverClose());
    this.addEventListener('focusin', () => this.openPBMHoverMenu());
    this.addEventListener('focusout', () => this.queuePBMHoverClose());

    this.summary.addEventListener(
      'click',
      (event) => {
        if (!this.isPBMDesktopHoverMenu() || event.detail === 0) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      { capture: true }
    );
  }

  isPBMDesktopHoverMenu() {
    return window.matchMedia('(min-width: 990px)').matches && this.closest('.header__inline-menu');
  }

  openPBMHoverMenu() {
    if (!this.isPBMDesktopHoverMenu()) return;
    clearTimeout(this.hoverCloseTimer);

    this.closest('.header__inline-menu')?.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', false);
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
    this.onToggle();
  }

  queuePBMHoverClose() {
    if (!this.isPBMDesktopHoverMenu()) return;

    clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = setTimeout(() => {
      if (this.matches(':hover') || this.contains(document.activeElement)) return;
      this.close();
      if (this.header) this.header.preventHide = false;
    }, 140);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
